(function(){
  // ✅ pull real URLs from window.GBM_ASSETS (set in Liquid before this script loads)
  var ASSET_URL = (window.GBM_ASSETS && window.GBM_ASSETS.zipCoords) || '';
  var LOCAL_URL = (window.GBM_ASSETS && window.GBM_ASSETS.localZips) || '';

  var HOME = [36.5484, -82.5618];  // 37664 (Kingsport, TN)
  var TTL_DAYS = 30;
  var LS_KEY = "GBM_ZIPS_V1";

  function now() { return Math.floor(Date.now()/1000); }
  function getStored() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "null"); } catch(e){ return null; }
  }
  function setStored(payload) {
    localStorage.setItem(LS_KEY, JSON.stringify({t: now(), payload: payload}));
  }
  function expired(stored) {
    if (!stored || !stored.t) return true;
    var age = now() - stored.t;
    return age > (TTL_DAYS * 86400);
  }

  function loadZipData(cb) {
    var cached = getStored();
    if (cached && !expired(cached)) {
      window.GBM_ZIPS = cached.payload;
      return cb && cb();
    }
    fetch(ASSET_URL, {cache: "force-cache"})
      .then(function(r){ return r.json(); })
      .then(function(data){
        window.GBM_ZIPS = data || {};
        setStored(window.GBM_ZIPS);
        cb && cb();
      })
      .catch(function(){
        // fallback to empty (treat as out of area if not found)
        window.GBM_ZIPS = window.GBM_ZIPS || {};
        cb && cb();
      });
  }

  // haversine miles
  function dmi(a, b) {
    var R = 3958.8;
    var dLat = (b[0]-a[0]) * Math.PI/180;
    var dLon = (b[1]-a[1]) * Math.PI/180;
    var lat1 = a[0]*Math.PI/180, lat2 = b[0]*Math.PI/180;
    var h = Math.sin(dLat/2)**2 + Math.cos(lat1)*Math.cos(lat2)*Math.sin(dLon/2)**2;
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  // Public helpers
  window.GBM_Zip = {
    ready: loadZipData,
    has: function(zip){ return !!(window.GBM_ZIPS && window.GBM_ZIPS[zip]); },
    milesFromHome: function(zip){
      if (!window.GBM_ZIPS || !window.GBM_ZIPS[zip]) return null;
      return dmi(HOME, window.GBM_ZIPS[zip]);
    },
    isShipEligible: function(zip, radiusMiles){
      radiusMiles = radiusMiles || 300;
      var dist = this.milesFromHome(zip);
      return (dist !== null) && dist <= radiusMiles;
    }
  };
  // ---- Load local ZIP list ----
(function(){
  var LOCAL_URL = (window.GBM_ASSETS && window.GBM_ASSETS.localZips) || '';
  fetch(LOCAL_URL, { cache: "force-cache" })
    .then(function(r){ return r.json(); })
    .then(function(list){
      window.GBM_LOCAL_ZIPS = new Set(list || []);
      console.log("Loaded local ZIPs:", window.GBM_LOCAL_ZIPS.size);
    })
    .catch(function(){
      window.GBM_LOCAL_ZIPS = new Set();
      console.warn("Local ZIPs file missing or invalid; defaulting to empty.");
    });
})();

})();
